import { useId } from 'react';
import type { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { TEST_IDS } from '@/testIds';
import { FieldError, SectionTextField } from '@/shared/ui';
import type { PassFormValues } from '../../model';

interface NameFieldProps {
  isEdit: boolean;
}

export const NameField: FC<NameFieldProps> = ({ isEdit }) => {
  const nameErrorId = useId();
  const {
    control,
    formState: { errors },
  } = useFormContext<PassFormValues>();

  const { field } = useController({
    name: 'name',
    control,
    rules: {
      required: 'Name is required',
      validate: (value) => (value.trim().length > 0 ? true : 'Name is required'),
    },
  });

  return (
    <>
      <SectionTextField
        ref={field.ref}
        ariaDescribedBy={errors.name ? nameErrorId : undefined}
        label="Name"
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        name={field.name}
        ariaLabel="Pass name"
        invalid={Boolean(errors.name)}
        testId={isEdit ? TEST_IDS.passEditModalNameInput : TEST_IDS.passAddModalNameInput}
      />
      <FieldError id={nameErrorId} message={errors.name?.message?.toString()} />
    </>
  );
};
